<template>
  <div>
    <div class="no-print">
      <el-button @click="printOrder" type="primary" size="small">打印单据</el-button>
      <el-button @click="exportPdf" type="primary" size="small">导出PDF</el-button>
    </div>

    <div id="printOrderBox" style="max-width:194mm;margin:0 auto;width:100%;">
      <h2 style="text-align:center;font-size:26px;margin-bottom:16px;">{{orderInfo.shop_name}}收费明细</h2>
      <p style="font-size:16px;margin:6px 0;">
        姓名：{{orderInfo.consignee}} &nbsp;&nbsp;&nbsp;&nbsp;
        编号：{{orderInfo.order_no}} &nbsp;&nbsp;&nbsp;&nbsp;
        日期：{{orderInfo.create_time}}
      </p>

     <table border="1" cellpadding="8" cellspacing="0" style="width:100%;table-layout:fixed;border-collapse:collapse;margin:12px 0;">
      <tr style="background:#f7f7f7;">
        <th style="width:7%;">序号</th>
        <th>商品名称</th>
        <th style="width:7%;">类型</th>
        <th style="width:7%;">规格</th>
        <th style="width:7%;">数量</th>
        <th style="width:10%;">价格</th>
      </tr>
      <tr v-if="orderList.length === 0">
        <td colspan="6" style="text-align:center;padding:20px 4px;color:#999;font-size:14px;">暂无商品信息</td>
      </tr>
      <tr v-for="(item,index) in orderList" :key="index">
        <td style="text-align:center;padding:7px 4px;word-break:break-all;font-size:13px;">{{index+1}}</td>
        <td style="text-align:center;padding:7px 4px;word-break:break-all;font-size:13px;">{{item.goods_name}}</td>
        <td style="text-align:center;padding:7px 4px;word-break:break-all;font-size:13px;">{{item.type}}</td>
        <td style="text-align:center;padding:7px 4px;word-break:break-all;font-size:13px;">{{item.spec_name}}</td>
        <td style="text-align:center;padding:7px 4px;word-break:break-all;font-size:13px;">{{item.number}}</td>
        <td style="text-align:center;padding:7px 4px;word-break:break-all;font-size:13px;">￥{{item.pay_price}}</td>
      </tr>
    </table>

      <div style="text-align:right;margin-top:15px;font-size:16px;">
        <p>商品合计：￥{{orderInfo.total_amount}}</p>
      </div>

      <div style="display:flex;justify-content:flex-end;margin-top:45px;font-size:16px;">
        <span>客户签字：___________</span>
        <!-- <span>打印日期：{{new Date().toLocaleDateString()}}</span> -->
      </div>
    </div>
  </div>
</template>

<script>
import { orderGoodsDetail,orderDetail } from '@/api/order'
export default {
  data() {
    return {
      orderInfo: {
      },
      orderList: []
    }
  },
  computed: {
  },
  mounted() {
    this.orderGoodsDetail();
  },
  methods: {
    orderGoodsDetail(){
      orderDetail({ order_id: this.$route.query.id }).then(res => {
        this.orderInfo = res;
      });
      orderGoodsDetail({ order_id: this.$route.query.id }).then(res => {
        console.log(res);
        this.orderList = res.goodsList;
      });
    },
    // 打印：iframe独立纯净页面，强制清除页眉页脚
    printOrder() {
      const printHtml = document.getElementById('printOrderBox').innerHTML;
      const iframe = document.createElement('iframe');
      iframe.style.width = '0px';
      iframe.style.height = '0px';
      document.body.appendChild(iframe);
      const doc = iframe.contentDocument;
      doc.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <meta charset="UTF-8">
        <title></title>
        <style>
          * {margin: 0;padding: 0;box-sizing: border-box;}
          body {width: 195mm;padding: 8mm;margin: 0 auto;}
          h2 {text-align: center;margin-bottom: 12px;}
          table {width:100%;table-layout:fixed;border-collapse: collapse;margin:10px 0;}
          td,th {border:1px solid #333;padding:7px 4px;text-align:center;}
          @page {margin: 12mm; size:A4;
            /* 关键：关闭页眉页脚 */
            @top-center { content: ""; }
            @bottom-center { content: ""; }
            @top-left { content: ""; }
            @top-right { content: ""; }
            @bottom-left { content: ""; }
            @bottom-right { content: ""; }
          }
        </style>
      </head>
      <body>
        ${printHtml}
      </body>
      </html>
      `);
      doc.close();
      iframe.onload = () => {
        iframe.contentWindow.print();
        setTimeout(() => document.body.removeChild(iframe), 300);
      }
    },

    // PDF导出：只截取#printOrderBox区域，不会抓取页面顶部多余文字
    exportPdf() {
      const element = document.getElementById('printOrderBox');
      const opt = {
        filename: `${this.orderInfo.order_no}-销售订单.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          letterRendering: true
        },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
        pagebreak: { avoid: ['table', 'tr'] }
      };
      window.html2pdf(element, opt);
    }
  }
}
</script>

<style scoped>
#printOrderBox {
  width: 700px;
  margin: 30px auto;
  padding: 20px;
}
</style>